import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-section-nav',
  templateUrl: './section-nav.component.html',
  styleUrls: ['./section-nav.component.scss']
})
export class SectionNavComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
